var styles = {
  "iconTile": "pb-IconTile__iconTile",
  "twoColumns": "pb-IconTile__twoColumns",
  "content": "pb-IconTile__content",
  "icon": "pb-IconTile__icon",
  "label": "pb-IconTile__label",
  "input": "pb-IconTile__input"
};
export default styles;